import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getDefaultOptions } from '@/library/components/form/inputs/select/api/api'; // Do NOT change this import
import queryClient from '@/utils/query';
import {
  OptionsRequestParams,
  UseQueryOptionsRequestParams
} from '@/library/components/form/inputs/select/types';
import { constructKeyFromPath } from '@/library/components/form/inputs/select/select-helpers';
import { listsKey } from '@/library/components/form/inputs/select/api/query-keys';

export const useDefaultOptionsQuery = <T = unknown>(
  options?: UseQueryOptionsRequestParams<T>,
  overrides?: Omit<UseQueryOptions<T[], Error>, 'enabled' | 'queryKey' | 'queryFn' | 'select'>
) => {
  const key = constructKeyFromPath(options?.path);
  const path = options?.path;
  const params = options?.params;
  const requestOptions = path ? { path, params } : undefined;

  return useQuery({
    queryKey: [listsKey, key, requestOptions],
    queryFn: () => getDefaultOptions<T>(requestOptions),
    enabled: options?.enabled !== undefined ? options.enabled : true,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes,
    select: options?.select,
    ...overrides
  });
};

export const invalidateDefaultOptionsQuery = (options: OptionsRequestParams) => {
  const key = constructKeyFromPath(options.path);
  const requestOptions = { path: options.path, params: options.params };

  return queryClient.invalidateQueries({
    queryKey: [listsKey, key, requestOptions]
  });
};
